import React from 'react';
import { useSingleTourGuide } from "./interactiveGuide";

export const withTourGuide = (WrappedComponent) => {
    return (props) => {
        const { showGuide, skipAllGuide, Overlay, isGuideActive, disabledKeys } = useSingleTourGuide();

        return (
            <>
                <WrappedComponent
                    {...props}
                    showGuide={showGuide}
                    skipAllGuide={skipAllGuide}
                    Overlay={Overlay}
                    isGuideActive={isGuideActive}
                    disabledKeys={disabledKeys}
                />
                {Overlay && <Overlay />}
            </>
        );
    };
};